import L from 'leaflet';

export const IconHazard = (severity = 'medium') => {
  // Define colors based on severity
  const severityColors = {
    low: '#f5222d',      // Green
    medium: '#f5222d',   // Orange
    high: '#f5222d',     // Dark Orange
    critical: '#f5222d'  // Red
  };

  // Pin and ring colors - using hazard red theme
  const pinColor = '#DC2626';
  const ringColor = '#991B1B';
  const accentColor = severityColors[severity] || '#DC2626';

  // Create SVG icon with new pin design (matching size with other asset icons)
  const svgIcon = `
    <svg width="94" height="104" viewBox="0 0 300 350" xmlns="http://www.w3.org/2000/svg">
      <!-- Pin base (Hazard red) -->
      <path d="M225 137.5 C225 89.2 185.8 50 137.5 50 S50 89.2 50 137.5 c0 48.3 87.5 192.5 87.5 192.5 s87.5-144.2 87.5-192.5 z" fill="${pinColor}"/>

      <!-- Status ring - Full circle in darker red -->
      <circle cx="137.5" cy="137.5" r="58.3" fill="none" stroke="${ringColor}" stroke-width="14"/>

      <!-- Icon background circle -->
      <circle cx="137.5" cy="137.5" r="42" fill="white"/>

      <!-- Hazard exclamation mark -->
      <path d="M137.5 105V145" stroke="${accentColor}" stroke-width="12" stroke-linecap="round"/>
      <circle cx="137.5" cy="162" r="7" fill="${accentColor}"/>
    </svg>
  `;

  return L.divIcon({
    html: svgIcon,
    className: `hazard-icon hazard-${severity}`,
    popupAnchor: null,
    shadowUrl: null,
    shadowSize: null,
    shadowAnchor: null,
    iconSize: [94, 104],
    iconAnchor: [34, 75],
  });
};